export type SeriesPointCandidate = {
  seriesIndex: number;
  dataIndex: number;
  pointY: number;
};

export type NearestSeriesGroup = Array<{
  seriesIndex: number;
  dataIndex: number;
}>;

export function findNearestSeriesGroup(
  candidates: SeriesPointCandidate[],
  pointerY: number,
  groupingThreshold: number
): NearestSeriesGroup {
  let nearestPointY: number | undefined;
  let nearestDistance = Number.POSITIVE_INFINITY;

  for (const candidate of candidates) {
    const distance = Math.abs(candidate.pointY - pointerY);

    if (distance >= nearestDistance) {
      continue;
    }

    nearestDistance = distance;
    nearestPointY = candidate.pointY;
  }

  if (nearestPointY === undefined) {
    return [];
  }

  const winnerPointY = nearestPointY;

  return candidates
    .filter((candidate) => Math.abs(candidate.pointY - winnerPointY) <= groupingThreshold)
    .map(({ seriesIndex, dataIndex }) => ({ seriesIndex, dataIndex }));
}
